
/**
 * Basic Layout, doesn't add anything really just a starting point.
 */


import * as React from 'react';
import { Component } from 'react';
import { Outlet } from "react-router-dom";


class BasicLayout extends Component {
    render() {
        return (
            <>
                <Outlet />
            </>
        )
    }
}


export default BasicLayout;